module.exports = "/img/about-gallery-4.ee8aedb7.png";